// Stałe dla systemu zadań

// Typy podmiotów
export const ENTITY_TYPES = {
  client: 'Klient',
  lead: 'Lead',
  general: 'Ogólne'
};

// Typy zadań
export const TASK_TYPES = {
  follow_up: 'Kontakt uzupełniający',
  proactive_offer: 'Oferta proaktywna',
  meeting_outcome_check: 'Sprawdzenie wyniku spotkania',
  data_update: 'Aktualizacja danych',
  other: 'Inne'
};

// Priorytety
export const PRIORITIES = {
  high: 'Wysoki',
  medium: 'Średni',
  low: 'Niski'
};

// Statusy zadań
export const TASK_STATUSES = {
  pending: 'Oczekujące',
  in_progress: 'W trakcie',
  completed: 'Ukończone',
  dismissed: 'Odrzucone'
};

// Źródła utworzenia zadania
export const CREATED_BY_TYPES = {
  user: 'Użytkownik',
  ai_system: 'System AI',
  manager: 'Manager'
};

// Funkcje pomocnicze
export const getEntityTypeLabel = (entityType) => {
  return ENTITY_TYPES[entityType] || entityType;
};

export const getTaskTypeLabel = (taskType) => {
  return TASK_TYPES[taskType] || taskType;
};

export const getPriorityLabel = (priority) => {
  return PRIORITIES[priority] || priority;
};

export const getStatusLabel = (status) => {
  return TASK_STATUSES[status] || status;
};

export const getCreatedByLabel = (createdBy) => {
  if (createdBy === 'ai_system') return CREATED_BY_TYPES.ai_system;
  if (createdBy === 'user_id_manager') return CREATED_BY_TYPES.manager;
  return CREATED_BY_TYPES.user;
};

// Kolory statusów
export const getPriorityColor = (priority) => {
  switch (priority) {
    case 'high':
      return 'error';
    case 'medium':
      return 'warning';
    case 'low':
      return 'info';
    default:
      return 'default';
  }
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'pending':
      return 'warning';
    case 'in_progress':
      return 'info';
    case 'completed':
      return 'success';
    case 'dismissed':
      return 'error';
    default:
      return 'default';
  }
};

export const getEntityTypeColor = (type) => {
  switch (type) {
    case 'client':
      return 'primary';
    case 'lead':
      return 'secondary';
    case 'general':
      return 'default';
    default:
      return 'default';
  }
};
